import { collectionEngineV1 } from '../apis';
const reqImports = collectionEngineV1('/imports', true);
export const addAppendix = (importId, fileId) => reqImports('POST', `/${importId}`, {
    body: { fileId },
});
export const getAmountAppendices = (importId) => reqImports('GET', `/amount-appendices/${importId}`);
export const get = (importId) => reqImports('GET', `/${importId}`);
export const create = (data) => reqImports('POST', '/', {
    body: data,
});
export const del = (importId) => reqImports('DELETE', '/' + importId);
export const patch = (importId, patch) => reqImports('PATCH', `/${importId}`, {
    body: patch,
});
export const getMigrationSample = (authToken, from, config) => reqImports('GET', `/migrate?from=${from}&config=${JSON.stringify(config)}`);
export const getAllImports = (from, quantity) => {
    let query = '?';
    if (from != undefined) {
        query = query + `offset=${from}`;
    }
    if (quantity != undefined) {
        query = query + `&limit=${quantity}`;
    }
    return reqImports('GET', query);
};
export const newCaseUpload = (importId, map, allDebtorsTerminated, allCasesFinallySettled) => reqImports('PUT', `/${importId}/start`, {
    body: {
        map,
        allDebtorsTerminated,
        allCasesFinallySettled,
    },
});
export const getFailedRows = (importId) => reqImports('GET', '/get-failed/' + importId);
export const importDebtorMessages = (body) => {
    return reqImports('POST', '/import-debtor-messages', { body });
};
//# sourceMappingURL=imports.js.map